module.exports = "<!-- <app-header></app-header> -->\r\n<!-- <div class=\"background-1\"></div> -->\r\n<router-outlet #appRouter=\"outlet\"></router-outlet>"